import React, { PropTypes, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { icons, positions } from '../icons';
import Translate from '../layout/Translate';

export default class TourStartMarker extends Component {

    componentDidMount() {

        
    }
    componentDidUpdate() {
    }
    componentWillUnmount() {
    }

    selectTour() {
        this.props.actions.selectMapTour({});
    }

    render () {

        return (
        <div className="map__info" style={{position: 'absolute',
                             opacity: this.props.scroll.opacity
                         }}>
            <div className="map__tour_opened map__tour">
                {!this.props.activeRoute &&
                    <div className="map__tour_info">
                        <Link to={"/tours/" + (this.props.tour.id)} className="map__tour_title">
                            <span className="map__tour_shadow_right">
                                <span className="map__tour_shadow_center">
                                    {this.props.tour.title}
                                </span>
                            </span>
                        </Link>
                        <Link to={"/tours/" + (this.props.tour.id_old?this.props.tour.id_old:this.props.tour.id)} className="map__tour_start">
                            <Translate slug="map__start" />
                        </Link>
                        <div className="map__close" onClick={this.selectTour.bind(this)}></div>
                    </div>
                }
            </div>

        </div>







        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/map/TourStartMarker.js